module.exports = __webpack_public_path__ + "img/chart-walking-phase-average-new.63639f59.png";